import React, { Component } from "react";
import Slide from "react-reveal";

class Resume extends Component {
  // ایجاد رنگ های رندوم برای نمودار skills
  // getRandomColor() {
  //   let letters = "0123456789ABCDEF";
  //   let color = "#";
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // }

  render() {
    if (!this.props.data) return null;

    // const skillmessage = this.props.data.skillmessage;

    // education side start

    const education = this.props.data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.degree}</h3>
          <p className="info">
            <a target="_blank" rel="noreferrer" href={education.url}>
              {education.school}
            </a>{" "}
            <span>&bull;</span>
            <em className="date">{education.graduated}</em>
          </p>
          <p>{education.description}</p>
          <hr className="hr-color" />
        </div>
      );
    });

    const Degrees = this.props.data.Degrees.map(function (Degrees) {
      return (
        <div key={Degrees.school}>
          <h3>
            {Degrees.degree} <br /> {Degrees.degree2}
          </h3>
          <p className="info">
            <a target="_blank" rel="noreferrer" href={Degrees.url}>
              {Degrees.school}
            </a>{" "}
            <span>&bull;</span>
            <em className="date">{Degrees.graduated}</em>
          </p>
          <p>
            <a target="_blank" rel="noreferrer" href={Degrees.degreesPicUrl}>
              {Degrees.degreesText}
            </a>
          </p>
          {/* <p>{Degrees.description}</p> */}
        </div>
      );
    });

    const work = this.props.data.work.map(function (work) {
      return (
        <div key={work.company}>
          <h3>{work.title}</h3>
          <p className="info">
            <a target="_blank" rel="noreferrer" href={work.url}>
              {work.company}
            </a>{" "}
            <span>&bull;</span> <em className="date">{work.years}</em>
          </p>
          <span>{work.description}</span>
          <br />
          <span>{work.description2}</span>
          <br />
          <span>{work.description3}</span>
          <br />
          <p>{work.description4}</p>
        </div>
      );
    });

    const skills = this.props.data.skills.map((skills) => {
      // const backgroundColor = this.getRandomColor();
      const className = "bar-expand " + skills.name.toLowerCase();
      const width = skills.level;

      return (
        <>
          <em>
            <span>{skills.name}</span>
            <span>({width})</span>
            <a href={skills.iconHref} target="_blank" rel="noreferrer">
              <img
                src={skills.iconSrc}
                width="30px"
                height="30px"
                alt={skills.iconAlt}
              />
            </a>
          </em>

          <li key={skills.name}>
            <span style={{ width }} className={className}></span>
          </li>
        </>
      );
    });

    return (
      <section id="resume">
        {/* education side start */}

        <Slide left duration={1300}>
          <div className="row education">
            <div className="three columns header-col">
              <h1>
                <span>Education</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">{education}</div>
              </div>
            </div>

            {/* Degrees */}

            <div className="three columns header-col ">
              <h1>
                <span>certificate</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">{Degrees}</div>
              </div>
            </div>

            {/* Degrees */}
          </div>
        </Slide>

        {/* education side END  */}

        {/* work side start  */}

        <Slide left duration={1300}>
          <div className="row work">
            <div className="three columns header-col">
              <h1 className="h1-up-down">
                <span>Work</span>
              </h1>
            </div>

            <div className="nine columns main-col">{work}</div>
          </div>
        </Slide>

        {/* work side END  */}

        {/* skills side start  */}

        <Slide left duration={1300}>
          <div className="row skill">
            <div className="three columns header-col">
              <h1>
                <span>Skills</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="bars">
                <ul className="skills">{skills}</ul>
              </div>
            </div>
          </div>
        </Slide>

        {/* skills side END  */}
      </section>
    );
  }
}

export default Resume;
